import { render, staticRenderFns } from "./DoinWalletTable.vue?vue&type=template&id=2ebffcbf&"
import script from "./DoinWalletTable.vue?vue&type=script&lang=js&"
export * from "./DoinWalletTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports